import {buildInternalUrl} from '@flexinet/analytics-components';

// SOURCE identifies this app in cross-property GA4 attribution. The seeder
// replaces the value below with the new app's APP_NAME so each generated
// app stamps its own utm_source on outbound internal links.
// See: docs/patterns/utm-tagging-pattern.md (cross-property attribution
// Pillar 1).
const SOURCE = 'flexinet-directory-app';

export const internalUrl = (
    baseUrl: string,
    opts: {campaign: string; content?: string; term?: string},
): string => buildInternalUrl(baseUrl, {source: SOURCE, ...opts});
